var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.gelenval == 'Aktif')?_c('vs-chip',{attrs:{"color":"success"}},[_vm._v("\n    "+_vm._s(_vm.gelenval)+"\n  ")]):_c('vs-chip',{attrs:{"color":"danger"}},[_vm._v("\n    "+_vm._s(_vm.gelenval)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }